import './checkout.css'
import Visa from "../Assets/visa.png"
import AmericanExpress from "../Assets/Americanexpress.png"
import Mastercard from "../Assets/mastercard.png"
import Paypal from "../Assets/paypal.png"
import { motion } from "framer-motion"

const Checkout = () => {
  const Loadvariants = {
    hidden: { opacity: 0,
    },
    visible: { opacity: 1,
       transition: {
            type: "spring",
            duration: 3
       },
    }
  }
  return(
    <section className='checkout'>
            <motion.div className="checkout__container"
               initial="hidden"
               animate="visible"
               variants={Loadvariants}
               exit={{
                 x: "-100vw",
                transition:{ ease: 'easeInOut'}
               }}
            >
                   <h2>Payment information</h2>

                <form action="">

                  <label htmlFor="number">Number:</label>
                  <input type="text" placeholder='Credit card number' id='number' required/>

                  <div className="sub__check">
                    <label htmlFor="expiry">Expiry:</label>
                    <input type="text" id='expiry' placeholder='MM  /  YY' required/>
                    <label htmlFor="cvc">CVC:</label>
                    <input type="text" id='cvc' placeholder='cvc' required/>
                  </div>

                  <button onClick={()=> alert("successful")}>Purchase</button>

                </form>
                <div className="payment__card Checkout__card">
                    <img src={Visa} alt="" />
                    <img src={AmericanExpress} alt="" />
                    <img src={Mastercard} alt="" />
                    <img src={Paypal} alt="" />
          </div>



            </motion.div>
    </section>
  )
}

export default Checkout